import React from 'react';
import RadarGrid from '../RadarGrid/RadarGrid.esm.js';
import RadarEntry from '../RadarEntry/RadarEntry.esm.js';
import RadarBubble from '../RadarBubble/RadarBubble.esm.js';
import RadarFooter from '../RadarFooter/RadarFooter.esm.js';
import RadarLegend from '../RadarLegend/RadarLegend.esm.js';

const RadarPlot = (props) => {
  const {
    width,
    height,
    radius,
    quadrants,
    rings,
    entries,
    activeEntry,
    onEntryMouseEnter,
    onEntryMouseLeave
  } = props;
  return /* @__PURE__ */ React.createElement("g", { "data-testid": "radar-plot" }, /* @__PURE__ */ React.createElement(
    RadarLegend,
    {
      quadrants,
      rings,
      entries,
      onEntryMouseEnter: onEntryMouseEnter && ((entry) => onEntryMouseEnter(entry)),
      onEntryMouseLeave: onEntryMouseLeave && ((entry) => onEntryMouseLeave(entry))
    }
  ), /* @__PURE__ */ React.createElement("g", { transform: `translate(${width / 2}, ${height / 2})` }, /* @__PURE__ */ React.createElement(RadarGrid, { radius, rings }), /* @__PURE__ */ React.createElement(
    RadarFooter,
    {
      x: -0.5 * width,
      y: 0.5 * height,
      spaces: rings.some((ring) => ring.description) ? 2 : void 0,
      labels: rings.map(
        (ring) => ring.description && `${ring.name}: ${ring.description}`
      ).filter((e) => e)
    }
  ), entries.map((entry) => /* @__PURE__ */ React.createElement(
    RadarEntry,
    {
      key: entry.id,
      x: entry.x || 0,
      y: entry.y || 0,
      color: entry.color || "",
      entryId: entry.id,
      value: (entry?.index || 0) + 1,
      url: entry.url,
      links: entry.links,
      description: entry.description,
      moved: entry.moved,
      title: entry.title,
      timeline: entry.timeline,
      onMouseEnter: onEntryMouseEnter && (() => onEntryMouseEnter(entry)),
      onMouseLeave: onEntryMouseLeave && (() => onEntryMouseLeave(entry))
    }
  )), /* @__PURE__ */ React.createElement(
    RadarBubble,
    {
      visible: !!activeEntry,
      text: activeEntry?.title || "",
      x: activeEntry?.x || 0,
      y: activeEntry?.y || 0
    }
  )));
};

export { RadarPlot as default };
//# sourceMappingURL=RadarPlot.esm.js.map
